import { Point } from '@/types';

export function subtractVectors({ x: x1, y: y1 }: Point, { x: x2, y: y2 }: Point): Point {
  return {
    x: x1 - x2,
    y: y1 - y2,
  };
}
